import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IClient } from '../models/client';

@Injectable({
  providedIn: "root",
})

export class CoachingAssignmentsService {
  baseUrl = environment.baseUrl

  constructor(private http: HttpClient) {}

  create(client_id: number, coach_id: number, start_date: string = null): Observable<IClient> {
    const url = `${this.baseUrl}/coaching_assignments`
    return this.http.post<IClient>(url, {coaching_assignment: {
      client_id,
      start_date,
      employee_id: coach_id
    }})
  }
}